import { usePrivacy } from '@/context/PrivacyContext';
import { cn } from '@/lib/utils';
import { Button } from '@opaz/ui-components';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PrivacyConsentBanner() {
  const { t } = useTranslation();
  const { hasConsentBeenSet, grantConsent, grantMinimumConsent, revokeConsent } = usePrivacy();

  if (hasConsentBeenSet) {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg',
        'animate-in slide-in-from-bottom duration-300',
        'pb-[env(safe-area-inset-bottom)]',
      )}
      role="dialog"
      aria-labelledby="privacy-consent-title"
      aria-describedby="privacy-consent-description"
    >
      <div className="max-w-container-960 mx-auto px-4 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Close button - only visible on mobile */}
          <button
            onClick={revokeConsent}
            className="md:hidden absolute top-4 end-4 text-gray-500 hover:text-gray-700"
            aria-label={t('privacyConsent.close')}
          >
            <X className="h-5 w-5" />
          </button>

          {/* Content */}
          <div className="flex-1 pr-8 md:pr-0">
            <h3 id="privacy-consent-title" className="text-lg font-bold mb-2 text-foreground">
              {t('privacyConsent.title')}
            </h3>
            <p id="privacy-consent-description" className="text-sm text-foreground mb-4">
              {t('privacyConsent.description')}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <Button
              variant="secondary"
              onClick={revokeConsent}
              className="w-full sm:w-auto min-w-24"
              aria-label={t('privacyConsent.decline')}
            >
              {t('privacyConsent.decline')}
            </Button>
            <Button
              variant="ghost"
              onClick={grantMinimumConsent}
              className="w-full sm:w-auto min-w-32"
              aria-label={t('privacyConsent.acceptMinimum')}
            >
              {t('privacyConsent.acceptMinimum')}
            </Button>
            <Button
              variant="default"
              onClick={grantConsent}
              className="w-full sm:w-auto min-w-24"
              aria-label={t('privacyConsent.accept')}
            >
              {t('privacyConsent.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
